import i18n from '../../i18n'

export const state = {
    marketplaces: [
        {
            text: i18n.t('common.marketplace.us'),
            value: 'us',
            marketplace_id: 'ATVPDKIKX0DER',
            region: 'na',
            domain: 'com'
        },
        {
            text: i18n.t('common.marketplace.ca'),
            value: 'ca',
            marketplace_id: 'A2EUQ1WTGCTBG2',
            region: 'na',
            domain: 'ca'
        },
        {
            text: i18n.t('common.marketplace.mx'),
            value: 'mx',
            marketplace_id: 'A1AM78C64UM0Y8',
            region: 'na',
            domain: 'com.mx'
        },
        {
            text: i18n.t('common.marketplace.br'),
            value: 'br',
            marketplace_id: 'A2Q3Y263D00KWC',
            region: 'na',
            domain: 'com.br'
        },
        {
            text: i18n.t('common.marketplace.es'),
            value: 'es',
            marketplace_id: 'A1RKKUPIHCS9HS',
            region: 'eu',
            domain: 'es'
        },
        {
            text: i18n.t('common.marketplace.gb'),
            value: 'gb',
            marketplace_id: 'A1F83G8C2ARO7P',
            region: 'eu',
            domain: 'co.uk'
        },
        {
            text: i18n.t('common.marketplace.fr'),
            value: 'fr',
            marketplace_id: 'A13V1IB3VIYZZH',
            region: 'eu',
            domain: 'fr'
        },
        {
            text: i18n.t('common.marketplace.nl'),
            value: 'nl',
            marketplace_id: 'A1805IZSGTT6HS',
            region: 'eu',
            domain: 'nl'
        },
        {
            text: i18n.t('common.marketplace.de'),
            value: 'de',
            marketplace_id: 'A1PA6795UKMFR9',
            region: 'eu',
            domain: 'de'
        },
        {
            text: i18n.t('common.marketplace.it'),
            value: 'it',
            marketplace_id: 'APJ6JRA9NG5V4',
            region: 'eu',
            domain: 'it'
        },
        {
            text: i18n.t('common.marketplace.se'),
            value: 'se',
            marketplace_id: 'A2NODRKZP88ZB9',
            region: 'eu',
            domain: 'se'
        },
        {
            text: i18n.t('common.marketplace.pl'),
            value: 'pl',
            marketplace_id: 'A1C3SOZRARQ6R3',
            region: 'eu',
            domain: 'pl'
        },
        {
            text: i18n.t('common.marketplace.eg'),
            value: 'eg',
            marketplace_id: 'ARBP9OOSHTCHU',
            region: 'eu',
            domain: 'eg'
        },
        {
            text: i18n.t('common.marketplace.tr'),
            value: 'tr',
            marketplace_id: 'A33AVAJ2PDY3EV',
            region: 'eu',
            domain: 'com.tr'
        },
        {
            text: i18n.t('common.marketplace.ae'),
            value: 'ae',
            marketplace_id: 'A2VIGQ35RCS4UG',
            region: 'eu',
            domain: 'ae'
        },
        {
            text: i18n.t('common.marketplace.in'),
            value: 'in',
            marketplace_id: 'A21TJRUUN4KGV',
            region: 'eu',
            domain: 'in'
        },
        {
            text: i18n.t('common.marketplace.sg'),
            value: 'sg',
            marketplace_id: 'A19VAU5U5O7RUS',
            region: 'fe',
            domain: 'sg'
        },
        {
            text: i18n.t('common.marketplace.au'),
            value: 'au',
            marketplace_id: 'A39IBJ37TRP1C6',
            region: 'fe',
            domain: 'com.au'
        },
        {
            text: i18n.t('common.marketplace.jp'),
            value: 'jp',
            marketplace_id: 'A1VC38T7YXB528',
            region: 'fe',
            domain: 'co.jp'
        }
    ],
}

export const mutations = {}

export const getters = {
    marketplaces(state) {
        return state.marketplaces
    }
}

export const actions = {}

